import { useDispatch, useSelector } from 'react-redux';
import FJMobileHistoryContainer from '../FJMainPreview/FJMobileHistory/FJMobileHistoryContainer';
import { useEffect, useCallback, useMemo } from 'react';
import FJActionImageManipulation from '../../redux/action/FJActionImageManipulation';
import FJMobileImageManipulationEditContainer from './FJMobileImageManipulationEdit/FJMobileImageManipulationEditContainer';
import FJMobileDefaultPreview from '../FJMainPreview/FJMobileDefaultPreview/FJMobileDefaultPreview';
import FJMobileCreationEditContainer from './FJMobileCreationEdit/FJMobileCreationEdit.container';
import { MOBILE_IMAGE_MANIPULATION_PREVIEW_SRC } from '../../config/dataConfig/FJImageManipulationData';
import FJActionBrushEditCommon from '../../redux/action/FJActionBrushEditCommon';
import { setSliceMobileGenerateSuccessPreviewIndex, setSliceTaskStatusAction } from '../../redux/slices/FJSliceCommon';
import FJConstant from '../../constants/FJConstant';
import FJConfig from '../../config/FJConfig';
import FJAppConstant from '../../constants/FJAppConstant';
import useLocalStore from '../../hooks/useLocalStore';
import FJLocalStore from '../../store/FJLocalStore';
import FJMobileGenerateSuccessfulContainer from '../FJMainPreview/FJMobileGenerateSuccessful/FJMobileGenerateSuccessfulContainer';

const FJMobileImageManipulation = () => {
    const dispatch = useDispatch();
    useLocalStore();

    const uploadImageInfo = useSelector(state => state.imageManipulation.uploadImageInfo);
    const creationList = useSelector(state => state.common.creationList);
    const hasUploadedImg = uploadImageInfo && uploadImageInfo.src;

    useEffect(() => {
        dispatch(FJActionImageManipulation.loadImageManipulationPageAction());
    }, [dispatch]);

    const uploadImg = useCallback(
        file => {
            dispatch(FJActionImageManipulation.uploadImageAction(file));
        },
        [dispatch],
    );
    const _gotoBack = useCallback(
        data => {
            // 移动端创作区没有对比功能
            // dispatch(setSliceDisableCompare(false));
            // dispatch(FJActionBrushEditCommon.updateCompareLineScaleAction(0.3));
            dispatch(FJActionBrushEditCommon.resetMaskAction());
            dispatch(
                FJActionBrushEditCommon.setEditImageAction({
                    src: data.imgUrl,
                }),
            );
            dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
            dispatch(setSliceMobileGenerateSuccessPreviewIndex(0));
        },
        [dispatch],
    );
    const onReEdit = useCallback(
        file => {
            dispatch(FJActionImageManipulation.uploadImageAction(file));
            dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
            dispatch(setSliceMobileGenerateSuccessPreviewIndex(0));
        },
        [dispatch],
    );
    const imageRect = useMemo(
        () => ({ width: uploadImageInfo.width, height: uploadImageInfo.height }),
        [uploadImageInfo],
    );
    const title =
            FJConfig.appType === FJAppConstant.PHOTO_RESTORATION
                ? 'ai-old-photo-restoration-colorful'
                : 'ai-photo-colorizer-colorful',
        description =
            FJConfig.appType === FJAppConstant.PHOTO_RESTORATION
                ? 'restore-old-photos-with-ai-and-bring-your-memories-back-to-life'
                : 'colorize-your-black-and-white-photos-with-ai-naturally-and-make-them-shine-again',
        uploadText = 'upload-image';
    return (
        <>
            {!hasUploadedImg && (
                <FJMobileDefaultPreview
                    title={title}
                    description={description}
                    uploadText={uploadText}
                    uploadImg={uploadImg}
                    videoSrc={MOBILE_IMAGE_MANIPULATION_PREVIEW_SRC}
                />
            )}
            {hasUploadedImg && (
                <>
                    <FJMobileGenerateSuccessfulContainer
                        gotoBack={_gotoBack}
                        onReEdit={onReEdit}
                        previewList={creationList}
                        gotoBackText={FJLocalStore._('re-upload')}
                        reEditText={FJLocalStore._('restore-more')}
                        imageRect={imageRect}
                    />
                    <FJMobileCreationEditContainer containerHeight={'calc(100% - 285px)'} />
                    <FJMobileImageManipulationEditContainer />
                </>
            )}
            <FJMobileHistoryContainer />
        </>
    );
};
export default FJMobileImageManipulation;
